import RandingStyle30 from "../../randing/RandingStyle30";

const footerText = `시술 및 수술 결과는 개인별 상태에 따라 달라질 수 있으며,
환자의 구강ㆍ치아 조건에 따라 치료 방법과 비용이 달라질 수 있습니다.

Copyright ⓒ 퍼널스

사업자등록번호 127-88-03197`;

const stepImageUrls = [
  "https://smilevent-assets.s3.ap-northeast-2.amazonaws.com/images/576/bottom01.jpg",
  "https://smilevent-assets.s3.ap-northeast-2.amazonaws.com/images/576/bottom02.jpg",
  "https://smilevent-assets.s3.ap-northeast-2.amazonaws.com/images/576/bottom03.jpg",
  "https://smilevent-assets.s3.ap-northeast-2.amazonaws.com/images/576/bottom04.jpg",
  "https://smilevent-assets.s3.ap-northeast-2.amazonaws.com/images/576/bottom05.jpg",
  "https://smilevent-assets.s3.ap-northeast-2.amazonaws.com/images/576/bottom06.jpg",
  "https://smilevent-assets.s3.ap-northeast-2.amazonaws.com/images/576/bottom07.jpg",
];

function Randing576({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle30
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      videoSrc="https://smilevent-assets.s3.ap-northeast-2.amazonaws.com/images/576/top.mp4"
      stepImageUrls={stepImageUrls}
      companyName="검단뉴욕치과의원"
      privacyCompanyName="검단뉴욕치과의원"
      privacyNewForm={true}
      privacyTrustee="(주)퍼널스"
      smoothTransition={true}
      hideFooter={true}
      footerText={footerText}
    />
  );
}

export default Randing576;
